import { Pipe, PipeTransform } from '@angular/core';
import {AppSettings} from "../models/AppSettings"

@Pipe({
  name: 'fileSize'
})
export class FileSizePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return AppSettings.humanFileSize(value,false);
  }

}



// WEBPACK FOOTER //
// ./src/app/service/file-size.pipe.ts